module.exports = (c = {}) => _.cloneDeep(c)


// WEBPACK FOOTER //
// ./app/Utilitaire/Function/Clone.js